import { makeStyles } from "@fluentui/react-components";

export const useEmptyPlaceholderStyles = makeStyles({
  container: {
    display: "flex",
    flex: "1 1 auto",
    height: "100%",
    overflow: "hidden",
    flexDirection: "column",
    justifyItems: "center",
    alignItems: "center",
    justifyContent: "center",
    alignContent: "center",
    opacity: 0.3,
    width: "100%",
  },
});
